import type { LegacyProductCode } from '@up2stay/up2promo-api-client';

/** Setup wizard: blank description is always OK — create derives via resolveSetupDescription. */
export function isSetupDescriptionOptional(
  _productType: LegacyProductCode | undefined,
): boolean {
  return true;
}
